import type { DeepPartial } from '@luna/utils-ts';

import type { StandingOrders } from './StandingOrders';

export const HU: DeepPartial<StandingOrders> = {
    sweepOrders: {
        enabled: false,
    },
};
